import { getIntervalInMinutes } from '@core/utils/utils'

export default {
  isReservationEnabled: (state: any) => state.business?.reservation?.enabled ?? 0,
  isReservationTableEnabled: (state: any) => state.business?.reservation?.with_table ?? 0,
  isReservationWithOrder: (state: any) => (state.business?.reservation?.type ?? 1) === 2,
  reservationMaxUsers: (state: any) => state.business?.reservation?.max_users ?? 1,
  reservationMinutesAdvance: (state: any) => getIntervalInMinutes(state.business?.reservation?.min_advance ?? {}),
}
